import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import useMyDashboards from '../../hooks/useMyDashboards';
import { dashboardPath, isDashboardPathname, sameDashboardId } from '../../utils/dashboards';

// Phone dashboard switcher: one dashboard is shown at a time, so this is a plain select in the
// header. Hidden unless the user has more than one dashboard and is on a dashboard page.
const MobileDashboardPicker = () => {
	const { pathname } = useLocation();
	const navigate = useNavigate();
	const { dashboards } = useMyDashboards();

	if (!isDashboardPathname(pathname) || !dashboards || dashboards.length < 2) return null;

	const current = pathname.startsWith('/dashboards/') ? pathname.slice('/dashboards/'.length) : null;
	const selected = dashboards.find((d) => current && sameDashboardId(d.id, current));

	return (
		<select
			className="mobile-dashboard-picker"
			aria-label="Dashboard"
			value={selected?.id ?? ''}
			onChange={(e) => navigate(dashboardPath(e.target.value))}
		>
			{!selected && <option value="" disabled>Choose a dashboard</option>}
			{dashboards.map((d) => (
				<option key={d.id} value={d.id}>{d.name}</option>
			))}
		</select>
	);
};

export default MobileDashboardPicker;
